export enum Size {
  xxxSmall, xxSmall, xSmall, small, medium, large, xLarge, xxLarge,auto_size
}